export async function fetchAgencyFlags(agencyId) {
    const base = process.env.COMCATE_API_URL;
    if (!base || !agencyId) {
        return null;
    }
    const root = base.replace(/\/$/, '');
    try {
        const res = await fetch(`${root}/agency/${agencyId}/flags`);
        if (!res.ok) {
            return null;
        }
        return res.json();
    }
    catch {
        return null;
    }
}
